


















































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import Tooltip from '@/components/UI/Tooltip.vue';
import ICopy from '@/components/icons/ICopy.vue'
import IArchive from '@/components/icons/IArchive.vue'
import IEdit from '@/components/icons/IEdit.vue'
import IRestore from '@/components/icons/IRestore.vue'
import Modal from '@/components/UI/Modal.vue';

const surveys = namespace('surveys')
@Component({
  components: {
    Tooltip,
    'i-copy': ICopy,
    'i-archive': IArchive,
    'i-edit': IEdit,
    'i-restore': IRestore,
    Modal
  }
})
export default class SurveysTable extends Vue {
  @surveys.Action('loadSurveysFromServer') protected loadSurveysFromServer:any
  @surveys.Action('updateSurvey')  protected updateSurvey:any
  @surveys.Getter('surveys') protected surveys: any
  @surveys.Getter('loading') protected loading: any

  @Prop({ type: String, default: {} }) protected search!: string;
  @Prop({type: Boolean, default: {}}) protected isShowArchive!: boolean

  get headers(){
    return [
      {text: '', sortable: false, value: 'isEdit', width: '68'},
      {text: this.$t('surveys.table.title'), sortable: true, value: 'title'},
      {text: this.$t('surveys.table.active'), sortable: false, value: 'isActive', width: "103"},
      {text: this.$t('surveys.table.questionsCount'), sortable: false, value: 'questionsCount', width: "128"},
      {text: this.$t('surveys.table.shardsCount'), sortable: true, value: 'countOfShards', width: "250"},
      {text: this.$t('surveys.table.updated'), sortable: true, value: 'updated', width: "250"},
      {text: this.$t('surveys.table.created'), sortable: true, value: 'created', width: "250"},
      {text: '', sortable: false, value: 'copy', width: '56'},
      {text: '', sortable: false, value: 'archive', width: '56'},
    ]
  }

  openModal:boolean = false
  currentSurvey:any = {}

  get surveysSearch() {
   if(this.search === '') return this.surveysArchive
    return this.surveysArchive.filter((el:any)=>{return el.survey.title.toLowerCase().includes(this.search.toLocaleLowerCase())})
  }

  get surveysArchive() {
    if(this.isShowArchive) return this.surveys
    return this.surveys.filter((el:any) => {return !el.survey.isArchived})
  }

  customSort(items:any, index:any, isDesc:any) {
    items.sort((a:any, b:any) => {
      if (index[0] === "updated") {
        if(!isDesc[0]) {
          return a.survey.updatedAtTimestamp - b.survey.updatedAtTimestamp;
        } else {
          return b.survey.updatedAtTimestamp - a.survey.updatedAtTimestamp;
        }
      } else if(index[0] === "created") {
        if(!isDesc[0]) {
          return a.survey.createdAtTimestamp - b.survey.createdAtTimestamp;
        } else {
          return b.survey.createdAtTimestamp - a.survey.createdAtTimestamp;
        }
      } else if(index[0] === "title") {
        if(!isDesc[0]) {
          return a.survey.title.localeCompare(b.survey.title);
        } else {
          return b.survey.title.localeCompare(a.survey.title);
        }
      } else if(index[0] === "countOfShards") {
        if(!isDesc[0]) {
          return a.countOfShards - b.countOfShards;
        } else {
          return b.countOfShards - a.countOfShards;
        }
      }
    });
    return items;
  }

  mounted() {
    this.loadSurveysFromServer()
  }

  changeActive(item:any) {
    let payload = {
      id: item.survey.id,
      params: {
        isActive: !item.survey.isActive
      }
    }
    this.updateSurvey(payload)
  }

  changeSurveyArchive() {
    let payload = {
      id: this.currentSurvey.survey.id,
      params: {
        isArchived: !this.currentSurvey.survey.isArchived
      },
      message: this.currentSurvey.survey.isArchived ? this.$t('tooltip.surveys.surveyRestored') : this.$t('tooltip.surveys.surveyArchived')
     }
    this.updateSurvey(payload)
    this.openModal = false
  }

  clickRow(item:any) {
    this.$emit('selectSurvey', item.survey.id)
    this.$router.push(
      {
        name: 'Survey', params: {
          survey: item.survey.id
        }
      }
    )
  }

  copy(item:any) {
    this.$emit('copySurvey', item)
  }

  showModal(item:any) {
    this.currentSurvey = item
    if(item.survey.isArchived) {
      this.changeSurveyArchive()
    } else {
      this.openModal = true
    }
  }

  timeConverter(UNIX_timestamp: any) {
    if(UNIX_timestamp == 0) return ''
    const a = new Date(UNIX_timestamp * 1000);
    const months = ['янв', 'фев', 'март', 'апр', 'май', 'июнь', 'июль', 'авг', 'сен', 'окт', 'ноя', 'дек'];
    const year = a.getFullYear().toString().slice(-2);
    const month = this.dable(a.getMonth() + 1);
    const date = this.dable(a.getDate());
    const clock = this.dable(a.getHours())
    const min = this.dable(a.getMinutes())
    const rTime = clock + ':' + min
    const rDate = date + '.' + month + '.' + year;

    return {rDate, rTime};
  }

  dable(num: number) {
    return num < 10 ? '0' + num : num
  }

}
